import { createContext } from 'react';
import utils from '../../utils';
import { Location } from 'react-router-dom';
import { AuthBody, LoginForm } from 'models/AuthBody';
import { NavigateBackConfig } from './hooks/usePreviousLocation';

type AuthContextValues = {
  isLoggedIn: boolean;
  previousLocation: Location;
  latestActivityMetricsLocation: Location;
  navigateBack: (config?: NavigateBackConfig) => void;
  loginRequest: (
    values: LoginForm,
    routeTo?: string | Location,
  ) => Promise<void>;
  socialLogin: (body: Omit<AuthBody, 'user'>) => void;
  logoutRequest: (routeTo?: string, isExternal?: boolean) => void;
  onLoginReq: (
    values: AuthBody,
    routeTo?: string | Location,
    externalRoute?: boolean,
  ) => void;
  switchUser: (authBody: AuthBody, routeTo?: string) => void;
  updateLatestActivityMetricsLocation: (location: Location) => void;
};

export default createContext<AuthContextValues>({
  isLoggedIn: false,
  previousLocation: null,
  latestActivityMetricsLocation: null,
  navigateBack: utils.noop,
  socialLogin: utils.noop,
  logoutRequest: utils.noop,
  loginRequest: utils.noop,
  onLoginReq: utils.noop,
  switchUser: utils.noop,
  updateLatestActivityMetricsLocation: utils.noop,
});
